export function buildDialogContentBoxAttributes(props) {

  const attributes = {};

  if (typeof props.contentContainerId === 'string') {
    attributes.id = props.contentContainerId;
  }

  return attributes;

}